import { Component } from '@angular/core';
import { UserService } from '../services/user.service';
import { Observable } from 'rxjs/Observable';
import { User } from '../model/user.class';
import { AuthHttp } from 'angular2-jwt/angular2-jwt';
import { NgTableComponent } from '../tableModel/ng-table.component';
import { NgTableFilteringDirective } from '../tableModel/ng-table-filtering.directive';
import { NgTablePagingDirective } from '../tableModel/ng-table-paging.directive';
import { NgTableSortingDirective } from '../tableModel/ng-table-sorting.directive';
import { Log } from '../model/log.class';
import { ActivatedRoute, Router } from '@angular/router';
import { MediaStatistic } from '../model/mediaStatistic.class';

@Component({
    selector: 'app-media-stat',
    templateUrl: './media.stat.component.html'
})
export class MediaStatComponent {

    mediaStats: MediaStatistic[];
    columns: Array<any> = [
        {
            title: 'Datum',
            name: 'date',
            sort: ''
        },
        {
            title: 'Anzahl Downloads',
            name: 'downloads',
            sort: ''
        },
        {
            title: 'Anzahl Uploads',
            name: 'uploads',
            sort: ''
        }
    ];

    constructor(public userService: UserService, private route: ActivatedRoute, private router: Router) {
        this.route.params.subscribe(
            (params) => {
                // tslint:disable-next-line:max-line-length
                userService.getStats(params['mediaId'], 'media').subscribe((mediaStats) => this.mediaStats = mediaStats as MediaStatistic[]);
            });

    }
}



// WEBPACK FOOTER //
// ./src/app/mediaStat/media.stat.component.ts